module.exports = __webpack_public_path__ + "static/media/veterinar-image.a2c649f9.jpg";